// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3WaJ6","label":"Radio_label__1Jt_J","checkMark":"Radio_checkMark__2bvMJ","disabled":"Radio_disabled__87pfL"};